// Persists DataGrid column widths per project in localStorage so a user's
// manual resizes survive a page refresh. Keyed by project id; maps the
// GridColDef `field` to its pixel width.

const KEY_PREFIX = 'rowtable-col-widths:'

export function loadColumnWidths(projectId: string): Record<string, number> {
    try {
        const raw = localStorage.getItem(KEY_PREFIX + projectId)
        return raw ? JSON.parse(raw) : {}
    } catch {
        return {}
    }
}

export function saveColumnWidth(projectId: string, field: string, width: number): void {
    try {
        const widths = loadColumnWidths(projectId)
        widths[field] = width
        localStorage.setItem(KEY_PREFIX + projectId, JSON.stringify(widths))
    } catch {
        // Ignore storage failures (private mode, quota, disabled storage).
    }
}
